import { SxProps } from '@mui/material';

export const BenefitsFrameSX: SxProps = {
	background: '#FAFCFF',
};

export const BenefitsContainerItemSX = () =>
	({
		width: '100%',
	} as SxProps);

export const BenefitsTitleSX: SxProps = {
	textAlign: 'center',
	marginBottom: 'var(--spacing-5)',
};
